<template>
  <div>
    <DashbaordHeader title="Edit Quotation">
      <v-row>
        <v-col :cols="isMobile ? 12 : 6" style="background: white">
          <v-container>
            <v-row>
              <v-col :cols="isMobile ? 12 : 6">
                <SelectClient
                  @client-selected="getSelectedClient"
                  @new-client-created="getSelectedClient"
                ></SelectClient>
                <SelectService
                  @service-selected="addServiceToSelectedServices"
                ></SelectService>
                <SelectProduct
                  @product-selected="addProductToSelectedProducts"
                ></SelectProduct>
                <SelectTransport
                  @transportation-selected="addTransportToSelectedTransports"
                ></SelectTransport>
                <DatesCommentsAndDiscounts
                  v-if="selectedClient"
                  @date-selected="getSelectedDate"
                  @get-discount-amount="getDiscountAmount"
                  @get-comment="getComment"
                >
                </DatesCommentsAndDiscounts>
              </v-col>
              <v-col :cols="isMobile ? 12 : 6">
                <v-alert
                  v-if="isMobile && selectedClient && selectedQuote"
                  :class="isMobile ? 'mx-4 mt-4 mb-2' : 'mt-4 mb-2'"
                  v-model="alert"
                  dismissible
                  color="cyan"
                  border="left"
                  elevation="2"
                  colored-border
                  icon="mdi-check"
                >
                  <p class="mb-n3">{{ selectedClient.name }}</p>
                  <small>[{{ selectedClient.institution }}]</small><br />
                  <strong
                    >Total Quote
                    {{
                      getCurrency +
                      formatMoney(selectedQuote.totalInvoiceAmount)
                    }}</strong
                  >
                </v-alert>
                <v-btn
                  :x-small="isMobile ? false : true"
                  dark
                  color="teal"
                  v-if="selectedClient"
                  rounded
                  :class="isMobile ? 'mx-6 mt-4 mb-2' : 'mt-4 mb-2'"
                  @click="savequoteData()"
                  ><v-icon>mdi-upload</v-icon> Save Quote To Database<v-icon
                    >mdi-database</v-icon
                  >
                </v-btn>

                <v-btn
                  :x-small="isMobile ? false : true"
                  dark
                  color="warning"
                  v-if="selectedClient"
                  rounded
                  :class="isMobile ? 'mx-6 mt-4 mb-2' : 'mt-4 mb-2'"
                  @click="DownloadQuotePdf()"
                  ><v-icon>mdi-download</v-icon>Download Quote As PDF
                  <v-icon>mdi-file-pdf</v-icon>
                </v-btn>

                <SelectedItem
                  v-if="selectedQuote.selectedServices.length > 0"
                  label="services"
                  :items="selectedQuote.selectedServices"
                  @update-line-total="updateLineTotal"
                  @remove-item="removeItem"
                ></SelectedItem>

                <SelectedItem
                  v-if="selectedQuote.selectedProducts.length > 0"
                  label="products"
                  :items="selectedQuote.selectedProducts"
                  @update-line-total="updateLineTotal"
                  @remove-item="removeItem"
                ></SelectedItem>

                <SelectedItem
                  v-if="selectedQuote.selectedTransports.length > 0"
                  label="transports"
                  :items="selectedQuote.selectedTransports"
                  @update-line-total="updateLineTotal"
                  @remove-item="removeItem"
                ></SelectedItem>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col v-if="!isMobile" :cols="isMobile ? 12 : 6">
          <iframe :src="pdf" width="100%" height="900"></iframe>
        </v-col>
      </v-row>
      <GlobalDialogSlot
        :title="dialogTitle"
        :dialog="dialog"
        @close-dialog="closeDialog"
      >
        <v-card>
          <v-card-title>{{ dialogTitle }}</v-card-title>
        </v-card>
      </GlobalDialogSlot>
    </DashbaordHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import pdfMakeParts from "@/plugins/pdfMakeParts";
import DashbaordHeader from "@/components/DashboardHeader.vue";
import SelectClient from "@/components/Clients/SelectClient.vue";
import SelectService from "./SelectService.vue";
import SelectProduct from "./SelectProduct.vue";
import SelectTransport from "./SelectTransport.vue";
import SelectedItem from "./SelectedItem.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import DatesCommentsAndDiscounts from "./DatesCommentsAndDiscounts.vue";

import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  props: ["selectedQuoteProp"],
  components: {
    DashbaordHeader,
    DatesCommentsAndDiscounts,
    SelectService,
    SelectClient,
    SelectProduct,
    SelectTransport,
    SelectedItem,
    GlobalDialogSlot,
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getOutlineColor() {
      return this.$store.getters.getOutlineColor;
    },
  },
  mounted() {
    if (
      this.$route.params.selectedQuote &&
      this.$route.params.selectedQuote != null
    ) {
      this.selectedQuote["tax_id"] = Number(
        this.$route.params.selectedQuote.tax_id
      );
      this.selectedQuote["description"] =
        this.$route.params.selectedQuote.description;
      this.selectedQuote.quoteNumber =
        this.$route.params.selectedQuote.quote_number;
    }

    this.$store.commit("setLoader", true);
    axios
      .postDataWithToken(
        "/auth/get-quote-data",
        { quoteNumber: this.selectedQuote.quoteNumber },
        this.getAccessToken
      )
      .then((data) => {
        this.quoteDate = data.quoteData.quote_date;
        this.selectedClient = data.quoteData.client;
        this.getSelectedClient(data.quoteData.client);
        this.selectedQuote.quoteNumber = data.quoteData.quote_number;

        data.services.forEach((service) => {
          this.addServiceToSelectedServices(service);
        });

        data.products.forEach((product) => {
          this.addProductToSelectedProducts(product);
        });

        data.transports.forEach((transport) => {
          this.addTransportToSelectedTransports(transport);
        });

        this.selectedQuote.totalServices = 0;
        this.selectedQuote.totalProducts = 0;
        this.selectedQuote.totalTransports = 0;
        this.selectedQuote.subTotal = data.quoteData.calculation.sub_total;
        this.selectedQuote.taxPercent = 0;
        this.selectedQuote.totalTax = data.quoteData.calculation.total_tax;

        this.selectedQuote.totalInvoiceAmount =
          data.quoteData.calculation.total;

        this.$store.commit("setLoader", false);
      });

    this.generatePDF(this);
  },
  data() {
    return {
      pdf: null,
      dialogTitle: null,
      dialog: false,
      quoteDate: new Date().toISOString().substr(0, 10),
      selectedClient: null,
      selectedQuote: {
        quoteNumber: null,
        selectedServices: [],
        selectedProducts: [],
        selectedTransports: [],
        totalServices: 0,
        subTotal: 0,
        taxPercent: 0,
        totalTax: 0,
        totalProducts: 0,
        totalTransports: 0,
        totalInvoiceAmount: 0,
        description: "Quotation",
        taxID: 0,
      },
    };
  },
  methods: {
    formatMoney(amount) {
      return axios.formatMoney(amount);
    },
    getSelectedClient(client) {
      this.selectedClient = client;
      this.generatePDF(this);
    },
    getSelectedDate(selectedDate) {
      this.quoteDate = selectedDate;
      this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    getDiscountAmount(discountAmount) {
      this.selectedQuote["tax_id"] = Number(discountAmount);
      this.reCalculateTotals();
      this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    getComment(comment) {
      this.selectedQuote.description = comment;
      this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    addServiceToSelectedServices(service) {
      if (service.unit_cost) {
        service.serviceFee = service.unit_cost;
        service.lineTotal = Number(service.lineTotal);
      } else {
        service.lineTotal = Number(service.serviceFee);
        service.quantity = 1;
      }

      this.selectedQuote.selectedServices.push(service);
      this.reCalculateTotals();
      this.generatePDF(this);
    },
    addProductToSelectedProducts(product) {
      if (product.unit_cost) {
        product.unitPrice = product.unit_cost;
        product.lineTotal = Number(product.lineTotal);
      } else {
        product.quantity = 1;
        product.lineTotal = Number(product.unitPrice);
      }

      this.selectedQuote.selectedProducts.push(product);
      this.reCalculateTotals();
      this.generatePDF(this);
    },
    addTransportToSelectedTransports(transport) {
      if (transport.unit_cost) {
        transport.unitPrice = transport.unit_cost;
        transport.lineTotal = Number(transport.lineTotal);
      } else {
        transport.lineTotal = Number(transport.transportationFee);
        transport.quantity = 1;
      }

      this.selectedQuote.selectedTransports.push(transport);
      this.reCalculateTotals();
      this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    updateLineTotal(itemArray) {
      const item = itemArray[1];
      if (itemArray[0] == "products") {
        item.lineTotal = (
          Number(item.unitPrice) * Number(item.quantity)
        ).toFixed(2);
      } else if (itemArray[0] == "services") {
        item.lineTotal = (
          Number(item.serviceFee) * Number(item.quantity)
        ).toFixed(2);
      } else if (itemArray[0] == "transports") {
        item.lineTotal = (
          Number(item.transportationFee) * Number(item.quantity)
        ).toFixed(2);
      }

      this.reCalculateTotals();
      this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    removeItem(arr) {
      const items = arr[0];
      const ind = arr[1];

      items.splice(ind, 1);
      this.reCalculateTotals();
      this.generatePDF(this, pdfMakeParts.getPdfStyles());
    },
    reCalculateTotals() {
      this.selectedQuote.subTotal = 0;
      if (this.selectedQuote.selectedServices.length > 0) {
        this.selectedQuote.selectedServices.forEach((service) => {
          this.selectedQuote.subTotal += Number(service.lineTotal);
        });
      }

      if (this.selectedQuote.selectedProducts.length > 0) {
        this.selectedQuote.selectedProducts.forEach((product) => {
          this.selectedQuote.subTotal += Number(product.lineTotal);
        });
      }

      if (this.selectedQuote.selectedTransports.length > 0) {
        this.selectedQuote.selectedTransports.forEach((transport) => {
          this.selectedQuote.subTotal += Number(transport.lineTotal);
        });
      }
      this.selectedQuote.totalTax = Number(
        (
          Number(this.selectedQuote.subTotal) *
          (Number(this.getUserCompany.tax_rate) / 100)
        ).toFixed(2)
      );
      this.selectedQuote.totalInvoiceAmount =
        Number(this.selectedQuote.subTotal) +
        Number(this.selectedQuote.totalTax) -
        Number(this.selectedQuote["tax_id"]);
    },
    generatePDF(vue) {
      const docDefinition = {
        content: vue.getContent(),
        styles: {
          header: {
            fontSize: 28,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#2196F3",
          },
          subHeader: {
            fontSize: 22,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 20],
            color: "#2196F3",
          },
          addressSection: {
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#000",
          },
          fillColumns: {
            margin: [0, 10, 0, 20],
          },
          tableStyle: {
            margin: [0, 10, 0, 20],
          },
          email: {
            fontSize: 12,
            color: "#2196F3",
            alignment: "center",
            decoration: "underline",
            margin: [0, 0, 0, 20],
          },
        },
      };

      pdfMake.createPdf(docDefinition).getDataUrl((dataUrl) => {
        this.pdf = dataUrl;
      });
    },
    DownloadQuotePdf() {
      const docDefinition = {
        content: this.getContent(),
        styles: {
          header: {
            fontSize: 28,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#2196F3",
          },
          subHeader: {
            fontSize: 22,
            bold: true,
            alignment: "center",
            margin: [0, 0, 0, 20],
            color: "#2196F3",
          },
          addressSection: {
            alignment: "center",
            margin: [0, 0, 0, 0],
            color: "#000",
          },
          fillColumns: {
            margin: [0, 10, 0, 20],
          },
          tableStyle: {
            margin: [0, 10, 0, 20],
          },
          email: {
            fontSize: 12,
            color: "#2196F3",
            alignment: "center",
            decoration: "underline",
            margin: [0, 0, 0, 20],
          },
        },
      };

      pdfMake
        .createPdf(docDefinition)
        .download(
          this.getUserCompany.name +
            " Quotation " +
            this.selectedQuote.quoteNumber
        );
    },
    productsDetailsTable(products) {
      const productsTableBody = [
        pdfMakeParts.myCustomMarginTop(),
        pdfMakeParts.productsHeader(),
      ];
      this.selectedQuote.totalProducts = 0;
      products.forEach((product) => {
        this.selectedQuote.totalProducts += Number(product.lineTotal);
        productsTableBody.push(pdfMakeParts.itemDetails(product));
      });
      return {
        style: ["tableStyle"],
        table: {
          widths: ["52%", "18%", "15%", "15%"],
          body: productsTableBody,
        },
      };
    },
    servicesDetailsTable(services) {
      const servicesTableBody = [
        pdfMakeParts.myCustomMarginTop(),
        pdfMakeParts.servicesHeader(),
      ];
      this.selectedQuote.totalServices = 0;
      services.forEach((service) => {
        this.selectedQuote.totalServices += Number(service.lineTotal);
        servicesTableBody.push(pdfMakeParts.itemDetails(service));
      });
      return {
        style: ["tableStyle"],
        table: {
          widths: ["52%", "18%", "15%", "15%"],
          body: servicesTableBody,
        },
      };
    },
    transportsDetailsTable(transports) {
      const transportsTableBody = [
        pdfMakeParts.myCustomMarginTop(),
        pdfMakeParts.transportsHeader(),
      ];
      this.selectedQuote.totalTransports = 0;
      transports.forEach((transport) => {
        this.selectedQuote.totalTransports += Number(transport.lineTotal);
        transportsTableBody.push(pdfMakeParts.itemDetails(transport));
      });
      return {
        style: [
          pdfMakeParts.getPdfStyles().tableStyle,
          pdfMakeParts.getPdfStyles().totalsPane,
        ],
        table: {
          widths: ["52%", "18%", "15%", "15%"],
          body: transportsTableBody,
        },
      };
    },
    getContent() {
      const content = [];
      const innerContent = [];

      innerContent.push(pdfMakeParts.companyHeader("QUOTATION"));
      if (this.selectedClient) {
        innerContent.push(
          pdfMakeParts.dateAndPersonalInfo(
            this.selectedClient,
            this.quoteDate,
            this.selectedQuote.quoteNumber,
            "Quotation"
          )
        );
      }
      if (this.selectedQuote.selectedProducts.length > 0) {
        innerContent.push(
          this.productsDetailsTable(this.selectedQuote.selectedProducts)
        );
      }

      if (this.selectedQuote.selectedServices.length > 0) {
        innerContent.push(
          this.servicesDetailsTable(this.selectedQuote.selectedServices)
        );
      }

      if (this.selectedQuote.selectedTransports.length > 0) {
        innerContent.push(
          this.transportsDetailsTable(this.selectedQuote.selectedTransports)
        );
      }

      if (
        this.selectedQuote.selectedServices.length > 0 ||
        this.selectedQuote.selectedProducts.length > 0 ||
        this.selectedQuote.selectedTransports.length > 0
      ) {
        innerContent.push(
          pdfMakeParts.tableTotalsPane(
            this.selectedQuote,
            this.selectedQuote.quoteNumber
          )
        );
      }

      if (this.selectedQuote && this.selectedQuote.description != "Quotation") {
        innerContent.push(
          pdfMakeParts.commentLine(this.selectedQuote.description)
        );
      }

      innerContent.push({
        text: `\n ${this.getUserCompany.name}`,
        alignment: "center",
      });

      innerContent.push({
        text: `\n created with BitsOffice [076 243 9441]`,
        alignment: "center",
      });
      content.push(innerContent);
      return content;
    },
    savequoteData() {
      this.$store.commit("setLoader", true);
      this.selectedQuote.selectedClient = this.selectedClient;
      this.selectedQuote.quoteDate = this.quoteDate;
      axios
        .postDataWithToken(
          "/auth/save-quote-data",
          this.selectedQuote,
          this.getAccessToken
        )
        .then((quoteData) => {
          this.$toast.success("Quotation Data Successfully Saved", {
            duration: 3000,
          });
          this.$store.commit("setLoader", false);
        });
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style></style>
